<template>
  <div>
    <!-- Botones de copia de descriptores (solo non-duoc y con contexto EPM) -->
    <div
      class="my-2 d-flex flex-wrap justify-content-end descriptor-copy-buttons"
    >
      <ContainerButtonsDownload
        v-if="
          matter &&
          !matter.use_matter_values &&
          allows_crud &&
          can_update &&
          PagePosition == 1 &&
          institution &&
          institution.internal_use_id != 'duoc.cl' &&
          user &&
          user.is_superuser
        "
        :id_button="`col-display-1-descriptors-${matter.id}`"
        :tooltip_text="''"
        class=""
        :text_button="$t('reusable.descriptorsContainer.copyDescriptors')"
      >
        <template #popover-container-buttons>
          <div>
            <ButtonMedium
              v-if="epm_to_targets.length > 0"
              :tooltip_text="``"
              :click_button="openEpmToEpmModal"
              :text_button="
                $t('reusable.descriptorsContainer.copyDescriptorsToEpm', {
                  entity: $getVisibleNames(
                    'mesh.egressprofilematter',
                    false,
                    'Asignatura'
                  ),
                  entity2: $getVisibleNames(
                    'mesh.egressprofile',
                    false,
                    'Perfil de Egreso'
                  ),
                })
              "
              :custom_class="`w-100 mb-1 text-left`"
              :icon="'files'"
              :variant="'primary'"
            >
            </ButtonMedium>
            <ButtonMedium
              v-if="epm_from_sources.length > 0"
              :tooltip_text="``"
              :click_button="openEpmFromEpmModal"
              :text_button="
                $t('reusable.descriptorsContainer.copyDescriptorsFromEpm', {
                  entity: $getVisibleNames(
                    'mesh.egressprofilematter',
                    false,
                    'Asignatura'
                  ),
                  entity2: $getVisibleNames(
                    'mesh.egressprofile',
                    false,
                    'Perfil de Egreso'
                  ),
                })
              "
              :custom_class="`w-100 mb-1 text-left`"
              :icon="'files'"
              :variant="'primary'"
            >
            </ButtonMedium>
            <ButtonMedium
              :tooltip_text="``"
              :click_button="openEpmToMatterModal"
              :text_button="
                $t('reusable.descriptorsContainer.copyDescriptorsToMatter', {
                  entityMatter: $getVisibleNames(
                    'teaching.matter',
                    false,
                    'Asignatura Base'
                  ),
                })
              "
              :custom_class="`w-100 mb-1 text-left`"
              :icon="'files'"
              :variant="'primary'"
            >
            </ButtonMedium>
            <ButtonMedium
              :tooltip_text="``"
              :click_button="openMatterToEpmModal"
              :text_button="
                $t('reusable.descriptorsContainer.copyDescriptorsFromMatter', {
                  entityMatter: $getVisibleNames(
                    'teaching.matter',
                    false,
                    'Asignatura Base'
                  ),
                })
              "
              :custom_class="`w-100 text-left`"
              :icon="'files'"
              :variant="'primary'"
            >
            </ButtonMedium>
          </div>
        </template>
      </ContainerButtonsDownload>
      <slot name="extra-actions"></slot>
    </div>
    <!-- forceFallback: Sortable controla el autoscroll (el nativo es lento y el
    navbar fijo tapa el borde superior); la sensibilidad cubre la altura del navbar.
    Las clases de arrastre dan el feedback de "tomado" (estilos sin scoped al final) -->
    <draggable
      v-model="myList"
      :disabled="!(allows_crud && can_update)"
      handle=".handle-descriptor"
      :group="drag_group"
      :animation="150"
      ghost-class="descriptor-drag-placeholder"
      chosen-class="descriptor-drag-chosen"
      fallback-class="descriptor-drag-fallback"
      :force-fallback="true"
      :fallback-on-body="true"
      :scroll-sensitivity="160"
      :scroll-speed="30"
      :bubble-scroll="true"
    >
      <!-- Sin contenidos el contenedor mide 0px y no recibe nada: zona punteada
      para soltar el que viene de otro apartado (el texto se oculta al entrar) -->
      <transition-group
        type="transition"
        :class="{ 'descriptor-drop-zone': showDropZone }"
        :data-empty-text="
          showDropZone ? $t('reusable.descriptorsContainer.dropZoneHint') : null
        "
      >
        <div
          :class="{
            'program-alter-container mb-2': ProgramView,
          }"
          v-for="element in myList"
          :key="element.id"
        >
          <template
            v-if="
              Title.find((x) => x.id == element.descriptor) &&
              Title.find((x) => x.id == element.descriptor).internal_use_id ==
                'duoc_pmd_methodological_strategy' &&
              matter
            "
          >
            <MethodologicalStrategyTable
              :ProfileMatter="matter"
              :allows_crud="false"
            ></MethodologicalStrategyTable>
          </template>
          <template
            v-if="
              Title.find((x) => x.id == element.descriptor) &&
              (Title.find((x) => x.id == element.descriptor).internal_use_id ==
                'duoc_pmd_te_evaluation_situation_expanded' ||
                Title.find((x) => x.id == element.descriptor).internal_use_id ==
                  'duoc_pmd_te_orientations_expanded' ||
                Title.find((x) => x.id == element.descriptor).internal_use_id ==
                  'duoc_pmd_matter_description' ||
                Title.find((x) => x.id == element.descriptor).internal_use_id ==
                  'duoc_key_suggestions_and_warnings_expanded') &&
              matter
            "
          >
            <DuocSpecialDescriptor
              v-if="institution && institution.internal_use_id == 'duoc.cl'"
              :internal_use_id="
                Title.find((x) => x.id == element.descriptor).internal_use_id
              "
              :matter="matter"
              :allows_crud="allows_crud"
              :PagePosition="PagePosition"
              :Text_info_tooltip="Text_info_tooltip"
              :Title_text="Title_text"
              :show_deleted_button="true"
              :can_delete="can_delete"
              :can_update="can_update"
              @updateState="(value) => $emit('updateState', value)"
              @createTitle="(value) => $emit('createTitle', value)"
              @updateTitle="(value) => $emit('updateTitle', value)"
              @createDescription="
                (object, text) => $emit('createDescription', object, text)
              "
              @deleteDescriptorsContent="deleteDescriptors"
              @updateDescription="
                (object, text) => $emit('updateDescription', object, text)
              "
            ></DuocSpecialDescriptor>
          </template>
          <div
            v-if="
              Title.find(
                (x) =>
                  x.id == element.descriptor && x.page_position == PagePosition
              ) &&
              (element.is_visible ||
                (allows_crud &&
                  can_update &&
                  isClosedOldMatterPartial(
                    Title.find((x) => x.id == element.descriptor)
                      .internal_use_id
                  ))) &&
              (element.description.trim() != 0 ||
                (allows_crud &&
                  can_update &&
                  isClosedOldMatterPartial(
                    Title.find((x) => x.id == element.descriptor)
                      .internal_use_id
                  )))
            "
            class="mb-2 outlined-div-secondary descriptor-wrapper"
            :class="{
              'outlined-tlr-div-black': ProgramView,
              'hidden-descriptor': allows_crud && !element.is_visible,
            }"
          >
            <span
              v-if="allows_crud && !element.is_visible"
              class="hidden-badge"
            >
              {{ $t("reusable.descriptorsContainer.hiddenInNormalView") }}
            </span>
            <div
              v-if="
                element.description.trim() != 0 ||
                (allows_crud &&
                  can_update &&
                  isClosedOldMatterPartial(
                    Title.find((x) => x.id == element.descriptor)
                      .internal_use_id
                  ))
              "
              class="descriptor-title"
              :class="{
                'text-light border-bottom-black btn-center': ProgramView,
              }"
            >
              <div
                v-if="
                  allows_crud &&
                  can_update &&
                  isClosedOldMatterPartial(
                    Title.find((x) => x.id == element.descriptor)
                      .internal_use_id
                  )
                "
                class="question-move handle-descriptor"
                :class="{
                  'grabbable-cursor':
                    allows_crud &&
                    can_update &&
                    isClosedOldMatterPartial(
                      Title.find((x) => x.id == element.descriptor)
                        .internal_use_id
                    ),
                }"
                @mousedown.prevent
              >
                <!-- mousedown.prevent: con force-fallback el navegador seleccionaba
                texto mientras se arrastra; Sortable escucha pointerdown, no se afecta -->
                <b-icon
                  class="move-icon"
                  icon="arrows-expand"
                  scale="1.3"
                ></b-icon>
              </div>
              <span class="descriptor-order" v-if="VisibleOrder">
                {{ element.order }}
              </span>
              <strong class="w-100" :class="{ 'custom-title': !ProgramView }">{{
                Title.find((x) => x.id == element.descriptor).title
              }}</strong>
              <template
                v-if="
                  allows_crud &&
                  (can_update || can_delete) &&
                  isClosedOldMatterPartial(
                    Title.find((x) => x.id == element.descriptor)
                      .internal_use_id
                  )
                "
              >
                <span>
                  <b-button
                    v-if="show_visible && can_update && allows_crud"
                    size="sm"
                    class="ml-1 p-0"
                    variant="none"
                    @click="showDescriptor(element)"
                  >
                    <template v-if="element.is_visible">
                      <ButtonSmall
                        :tooltip_text="$t('reusable.common.show')"
                        :custom_class="'text-white'"
                        :icon="'eye'"
                      ></ButtonSmall>
                      <!-- <b-icon
                        class="btn-actions"
                        icon="eye"
                        v-b-tooltip.v-secondary.noninteractive="
                          $t('reusable.common.show')
                        "
                        scale="1"
                      ></b-icon> -->
                    </template>
                    <template v-else>
                      <ButtonSmall
                        :tooltip_text="$t('reusable.common.hide')"
                        :custom_class="'text-white'"
                        :icon="'eye-slash'"
                      ></ButtonSmall>
                      <!-- <b-icon
                        class="btn-actions"
                        v-b-tooltip.v-secondary.noninteractive="
                          $t('reusable.common.hide')
                        "
                        icon="eye-slash"
                        scale="1"
                      ></b-icon> -->
                    </template>
                  </b-button>
                </span>
                <ButtonSmall
                  v-if="can_update && allows_crud"
                  :tooltip_text="$t('reusable.common.edit')"
                  :click_button="
                    () =>
                      slotUpdatedTitle(
                        Title.find((x) => x.id == element.descriptor)
                      )
                  "
                  :class="`mx-1`"
                  :custom_class="'text-white'"
                  :icon="'square'"
                ></ButtonSmall>
                <!-- <span
                  v-if="
                    institution &&
                    institution.internal_use_id == 'duoc.cl' &&
                    Title.find((x) => x.id == element.descriptor) &&
                    Title.find((x) => x.id == element.descriptor)
                      .internal_use_id != null &&
                    ProgramView
                  "
                  v-b-tooltip.v-secondary.auto.noninteractive="
                    `Este objeto es necesarios para el funcionamiento de la maleta didáctica.`
                  "
                >
                  <button-delete disabled></button-delete>
                </span> -->
                <!-- Eliminar -->
                <ButtonSmall
                  v-if="can_delete && allows_crud"
                  :click_button="() => deleteDescriptors(element)"
                  :tooltip_text="
                    $t('reusable.descriptorsContainer.clearContent')
                  "
                  :class="`mr-1`"
                  :icon="'trash'"
                  :variant="'danger'"
                  :variant_icon="'light'"
                ></ButtonSmall>
                <!-- <b-button
                  class="ml-1 mr-1 p-0"
                  variant="none"
                  @click="deleteDescriptors(element)"
                  v-b-tooltip.v-secondary.noninteractive="`Limpiar Contenido`"
                >
                  <b-icon-x-square></b-icon-x-square>
                </b-button> -->
              </template>
            </div>
            <div>
              <RenderVHtml
                class="descriptor-body"
                :content="element.description"
              ></RenderVHtml>
              <div
                v-if="
                  allows_crud &&
                  can_update &&
                  isClosedOldMatterPartial(
                    Title.find((x) => x.id == element.descriptor)
                      .internal_use_id
                  )
                "
              >
                <ButtonSmall
                  :tooltip_text="`${
                    Title.find((x) => x.id == element.descriptor).title
                  }`"
                  :click_button="
                    () =>
                      $bvModal.show(
                        `${ref_component}edit-description-modal-${element.id}`
                      )
                  "
                  :class="`btn-center`"
                  :icon="'square'"
                ></ButtonSmall>
                <!-- <button-edit
                  class="btn-center"
                  @click="
                    $bvModal.show(
                      `${ref_component}edit-description-modal-${element.id}`
                    )
                  "
                  v-b-tooltip.v-secondary.noninteractive="
                    `${Title.find((x) => x.id == element.descriptor).title}`
                  "
                >
                </button-edit> -->
                <template v-if="rich_text_editor">
                  <ContainerRichTextKlv3
                    :id_modal="`${ref_component}edit-description-modal-${element.id}`"
                    :title_modal="`${
                      Title.find((x) => x.id == element.descriptor).title
                    }`"
                    :size_modal="`lg`"
                    :content_rich_text="element.description"
                    :object_rich_text="element"
                    :show_last_modification="true"
                    :permit_blank="true"
                    @save="(content) => updateDescription(element, content)"
                    @close="
                      $bvModal.hide(
                        `${ref_component}edit-description-modal-${element.id}`
                      )
                    "
                  >
                    <!-- <template #oldRich>
                      <NewRichTextEditor
                        :Object="element"
                        :Text="element.description"
                        :permit_blank="true"
                        :show_last_modification="true"
                        :object_last_modification="element"
                        @save="updateDescription"
                        @close="
                          $bvModal.hide(
                            `${ref_component}edit-description-modal-${element.id}`
                          )
                        "
                      ></NewRichTextEditor>
                    </template> -->
                  </ContainerRichTextKlv3>
                </template>
                <template v-else>
                  <b-modal
                    :id="`${ref_component}edit-description-modal-${element.id}`"
                    :title="`${
                      Title.find((x) => x.id == element.descriptor).title
                    }`"
                    size="xl"
                    hide-footer
                    ignore-enforce-focus-selector="#sidebar-right"
                  >
                    <TextArea
                      :showSaveBtn="true"
                      :clearTextArea="false"
                      :Text="element.description"
                      :show_last_modification="true"
                      :object_last_modification="element"
                      @update="
                        (Text) => {
                          updateDescription(element, Text);
                          $bvModal.hide(
                            `${ref_component}edit-description-modal-${element.id}`
                          );
                        }
                      "
                    ></TextArea>
                  </b-modal>
                </template>
                <!-- <b-modal
                  :id="`${ref_component}edit-description-modal-${element.id}`"
                  :title="`${
                    Title.find((x) => x.id == element.descriptor).title
                  }`"
                  size="xl"
                  hide-footer
                  ignore-enforce-focus-selector="#sidebar-right"
                >
                  <template v-if="rich_text_editor">
                    <NewRichTextEditor
                      :Object="element"
                      :Text="element.description"
                      :permit_blank="true"
                      :show_last_modification="true"
                      :object_last_modification="element"
                      @save="updateDescription"
                      @close="
                        $bvModal.hide(
                          `${ref_component}edit-description-modal-${element.id}`
                        )
                      "
                    ></NewRichTextEditor>
                  </template>
                  <template v-else>
                    <div>
                      <TextArea
                        :showSaveBtn="true"
                        :clearTextArea="false"
                        :Text="element.description"
                        :show_last_modification="true"
                        :object_last_modification="element"
                        @update="
                          (Text) => {
                            updateDescription(element, Text);
                            $bvModal.hide(
                              `${ref_component}edit-description-modal-${element.id}`
                            );
                          }
                        "
                      ></TextArea>
                    </div>
                  </template>
                </b-modal> -->
              </div>
            </div>
          </div>
          <!-- FormationLine Description -->
          <template
            v-if="
              getFormationLineDescription != null &&
              Title.find((x) => x.id == element.descriptor) &&
              Title.find((x) => x.id == element.descriptor).internal_use_id ==
                'duoc_pmd_matter_description' &&
              ProgramView &&
              matter
            "
          >
            <div
              class="my-2 outlined-div-secondary"
              :class="{ 'outlined-div-black': ProgramView }"
            >
              <div
                class="descriptor-title"
                :class="{
                  'border-bottom-black':
                    ProgramView &&
                    allows_crud &&
                    can_update &&
                    isClosedOldMatterPartial(
                      Title.find((x) => x.id == element.descriptor)
                        .internal_use_id
                    ),
                  'text-light btn-center': ProgramView,
                }"
              >
                <strong>
                  {{ $t("reusable.descriptorsContainer.descriptionOf") }}
                  {{
                    $getVisibleNames(
                      "mesh.formationline",
                      false,
                      "Línea De Formación"
                    )
                  }}</strong
                >
              </div>

              <RenderVHtml
                class="descriptor-body"
                :content="getFormationLineDescription"
              ></RenderVHtml>
            </div>
          </template>
        </div>
      </transition-group>
    </draggable>

    <div v-for="item in Title" :key="item.id">
      <template
        v-if="
          myList.filter((x) => x.descriptor == item.id).length == 0 &&
          allows_crud &&
          can_update &&
          item.internal_use_id == 'duoc_pmd_methodological_strategy' &&
          matter
        "
      >
        <MethodologicalStrategyTable
          :ProfileMatter="matter"
          :allows_crud="false"
        ></MethodologicalStrategyTable>
      </template>
      <template
        v-if="
          myList.filter((x) => x.descriptor == item.id).length == 0 &&
          allows_crud &&
          can_update &&
          (item.internal_use_id ==
            'duoc_pmd_te_evaluation_situation_expanded' ||
            item.internal_use_id == 'duoc_pmd_matter_description' ||
            item.internal_use_id == 'duoc_pmd_te_orientations_expanded' ||
            item.internal_use_id ==
              'duoc_key_suggestions_and_warnings_expanded') &&
          matter
        "
      >
        <DuocSpecialDescriptor
          v-if="institution && institution.internal_use_id == 'duoc.cl'"
          :internal_use_id="item.internal_use_id"
          :matter="matter"
          :allows_crud="allows_crud"
          :PagePosition="PagePosition"
          :Text_info_tooltip="Text_info_tooltip"
          :Title_text="Title_text"
          :can_delete="can_delete"
          :can_update="can_update"
          @updateState="(value) => $emit('updateState', value)"
          @createTitle="(value) => $emit('createTitle', value)"
          @updateTitle="(value) => $emit('updateTitle', value)"
          @createDescription="
            (object, text) => $emit('createDescription', object, text)
          "
          @updateDescription="
            (object, text) => $emit('updateDescription', object, text)
          "
        ></DuocSpecialDescriptor>
      </template>
      <div
        class="my-2 outlined-div-secondary descriptor-wrapper"
        :class="{
          'outlined-div-black': ProgramView,
          'hidden-descriptor': allows_crud && !show_matter_descriptor,
        }"
        v-if="
          myList.filter((x) => x.descriptor == item.id).length == 0 &&
          ((allows_crud && (can_update || can_delete)) ||
            show_matter_descriptor) &&
          isClosedOldMatterPartial(item.internal_use_id)
        "
      >
        <span
          v-if="allows_crud && !show_matter_descriptor"
          class="hidden-badge"
        >
          {{ $t("reusable.descriptorsContainer.hiddenInNormalView") }}
        </span>
        <div
          class="descriptor-title"
          :class="{
            'border-bottom-black':
              ProgramView &&
              allows_crud &&
              (can_update || can_delete) &&
              isClosedOldMatterPartial(item.internal_use_id),
            'text-light btn-center': ProgramView,
          }"
        >
          <strong class="w-100">{{ item.title }}</strong>
          <template
            v-if="
              allows_crud &&
              (can_update || can_delete) &&
              isClosedOldMatterPartial(item.internal_use_id)
            "
          >
            <ButtonSmall
              v-if="can_update && allows_crud"
              :tooltip_text="$t('reusable.common.edit')"
              :click_button="() => slotUpdatedTitle(item)"
              :class="`mx-1`"
              :icon="'square'"
              :custom_class="'text-white'"
            ></ButtonSmall>
            <span
              v-if="
                institution &&
                institution.internal_use_id == 'duoc.cl' &&
                item.internal_use_id != null &&
                ProgramView
              "
              v-b-tooltip.v-secondary.auto.noninteractive="
                $t('reusable.descriptorsContainer.necessaryObjectWarning')
              "
            >
              <ButtonSmall
                v-if="can_delete && canDeleteTitle(item) && allows_crud"
                :tooltip_text="``"
                :class="`mr-1`"
                :disabled_button="true"
                :icon="'trash'"
                :variant="'danger'"
                :variant_icon="'light'"
              ></ButtonSmall>
            </span>
            <!-- Eliminar -->
            <ButtonSmall
              v-else-if="can_delete && canDeleteTitle(item) && allows_crud"
              :click_button="() => deleteTitle(item)"
              :tooltip_text="$t('reusable.common.delete')"
              :class="`mx-1`"
              :icon="'trash'"
              :variant="'danger'"
              :variant_icon="'light'"
            ></ButtonSmall>
          </template>
        </div>
        <!-- class="descriptor-body" -->
        <div
          v-if="
            allows_crud &&
            can_update &&
            isClosedOldMatterPartial(item.internal_use_id)
          "
        >
          <ButtonSmall
            v-if="can_update && allows_crud"
            :tooltip_text="`${item.title}`"
            :click_button="
              () =>
                $bvModal.show(
                  `${ref_component}add-description-modal-${item.id}`
                )
            "
            :class="`btn-center`"
            :icon="'plus'"
            :variant="'none'"
          >
          </ButtonSmall>
          <!-- <button-add
            class="btn-center"
            @click="
              $bvModal.show(`${ref_component}add-description-modal-${item.id}`)
            "
            v-b-tooltip.v-secondary.noninteractive="`${item.title}`"
          >
          </button-add> -->
          <template v-if="rich_text_editor">
            <ContainerRichTextKlv3
              :id_modal="`${ref_component}add-description-modal-${item.id}`"
              :title_modal="`${item.title}`"
              :size_modal="`lg`"
              :object_rich_text="item"
              :show_last_modification="true"
              :permit_blank="true"
              @save="(content) => createDescription(content, item)"
              @close="
                $bvModal.hide(
                  `${ref_component}add-description-modal-${item.id}`
                )
              "
            >
            </ContainerRichTextKlv3>
          </template>
          <template v-else>
            <b-modal
              :id="`${ref_component}add-description-modal-${item.id}`"
              :title="`${item.title}`"
              size="xl"
              hide-footer
              ignore-enforce-focus-selector="#sidebar-right"
            >
              <TextArea
                :showSaveBtn="true"
                :clearTextArea="false"
                @update="
                  (Text) => {
                    createDescription(Text, item);
                    $bvModal.hide(
                      `${ref_component}add-description-modal-${item.id}`
                    );
                  }
                "
              ></TextArea>
            </b-modal>
          </template>
          <!-- <b-modal
            :id="`${ref_component}add-description-modal-${item.id}`"
            :title="`${item.title}`"
            size="xl"
            hide-footer
            ignore-enforce-focus-selector="#sidebar-right"
          >
            <template v-if="rich_text_editor">
              <NewRichTextEditor
                :Type="item"
                :permit_blank="true"
                @save="createDescription"
                @close="
                  $bvModal.hide(
                    `${ref_component}add-description-modal-${item.id}`
                  )
                "
              ></NewRichTextEditor>
            </template>
            <template v-else>
              <div>
                <TextArea
                  :showSaveBtn="true"
                  :clearTextArea="false"
                  @update="
                    (Text) => {
                      createDescription(Text, item);
                      $bvModal.hide(
                        `${ref_component}add-description-modal-${item.id}`
                      );
                    }
                  "
                ></TextArea>
              </div>
            </template>
          </b-modal> -->
        </div>
      </div>
      <!-- FormationLine Description -->
      <template
        v-if="
          myList.filter((x) => x.descriptor == item.id).length == 0 &&
          allows_crud &&
          can_update &&
          getFormationLineDescription != null &&
          item.internal_use_id == 'duoc_pmd_matter_description' &&
          ProgramView &&
          matter
        "
      >
        <div
          class="my-2 outlined-div-secondary"
          :class="{ 'outlined-div-black': ProgramView }"
        >
          <div
            class="descriptor-title"
            :class="{
              'border-bottom-black':
                ProgramView &&
                allows_crud &&
                can_update &&
                isClosedOldMatterPartial(item.internal_use_id),
              'text-light btn-center': ProgramView,
            }"
          >
            <strong>
              {{ $t("reusable.descriptorsContainer.descriptionOf") }}
              {{
                $getVisibleNames(
                  "mesh.formationline",
                  false,
                  "Línea De Formación"
                )
              }}</strong
            >
          </div>
          <RenderVHtml
            class="descriptor-body"
            :content="getFormationLineDescription"
          ></RenderVHtml>
        </div>
      </template>
    </div>
    <b-modal
      :id="`${ref_component}title-modal`"
      :title="
        isNaN(title_proccess.id)
          ? $t('reusable.descriptorsContainer.createTitle')
          : $t('reusable.descriptorsContainer.editTitle')
      "
      size="xl"
      @hide="resetTitleModal"
      hide-footer
      ignore-enforce-focus-selector="#sidebar-right"
    >
      <b-form-group
        label-cols="0"
        label-cols-sm="2"
        label-for="descriptor-title-input"
      >
        <template #label>
          <span id="descriptor-title-input" class="descriptor-title-label">{{
            $t("reusable.descriptorsContainer.title")
          }}</span>
        </template>
        <div>
          <div>
            <b-form-input
              id="descriptor-title-input"
              v-model="title_proccess.title"
              aria-describedby="input-title-live-feedback"
              size="sm"
            ></b-form-input>
            <b-form-invalid-feedback id="input-title-live-feedback">
              <div>
                {{ $t("reusable.common.minLength", { min: 1 }) }}
              </div>
            </b-form-invalid-feedback>
          </div>
          <div class="mt-2 d-flex w-100">
            <template v-if="show_is_default">
              <template v-if="title_proccess.internal_use_id == null">
                <b-form-checkbox
                  class="descriptor-title-check w-100"
                  v-model="title_proccess.is_default"
                  >{{ $t("reusable.descriptorsContainer.default") }}
                  <InfoTooltip
                    class="selection-info ml-0"
                    :tooltip_text="`${Text_info_tooltip}`"
                  >
                  </InfoTooltip>
                </b-form-checkbox>
              </template>
              <template v-else>
                <b-form-checkbox
                  class="descriptor-title-check w-100"
                  :checked="title_proccess.is_default"
                  :disabled="true"
                  >{{ $t("reusable.descriptorsContainer.default") }}
                  <InfoTooltip
                    class="selection-info ml-0"
                    :tooltip_text="`${Text_info_tooltip}`"
                  >
                  </InfoTooltip>
                </b-form-checkbox>
              </template>
            </template>
          </div>
        </div>
      </b-form-group>
      <b-button
        size="sm"
        variant="primary"
        class="float-right"
        @click="save(title_proccess)"
      >
        <!-- :disabled="title_proccess.title.trim().length < 0" -->
        {{ $t("reusable.descriptorsContainer.saveTitle") }}
      </b-button>
    </b-modal>

    <!-- Modal EPM → EPM -->
    <b-modal
      v-if="matter"
      :id="`${ref_component}copy-epm-to-epm-modal`"
      :title="
        $t('reusable.descriptorsContainer.copyDescriptorsToEpm', {
          entity: $getVisibleNames(
            'mesh.egressprofilematter',
            false,
            'Asignatura'
          ),
          entity2: $getVisibleNames(
            'mesh.egressprofile',
            false,
            'Perfil de Egreso'
          ),
        })
      "
      size="lg"
      hide-footer
    >
      <div class="copy-desc-options">
        <b-alert show variant="info" class="mb-3 small">
          <b-icon icon="info-circle-fill" class="mr-1"></b-icon>
          <RenderVHtml
            class="d-inline p-0"
            :content="
              $t('reusable.descriptorsContainer.copyEpmToEpmDescriptorsDesc', {
                entity: $getVisibleNames(
                  'mesh.egressprofilematter',
                  false,
                  'Asignatura'
                ),
                entityProfile: $getVisibleNames(
                  'mesh.egressprofile',
                  false,
                  'Perfil de Egreso'
                ),
              })
            "
          ></RenderVHtml>
        </b-alert>
        <b-form-select
          v-model="copy_target_epm_id"
          :options="availableToEpmsOptions"
          size="sm"
          class="mb-3"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>
              {{
                $t("reusable.descriptorsContainer.selectTargetEpm", {
                  entity: $getVisibleNames(
                    "mesh.egressprofilematter",
                    false,
                    "Asignatura"
                  ),
                })
              }}
            </b-form-select-option>
          </template>
        </b-form-select>
        <div class="copy-desc-preview-container mb-3">
          <!-- Origen: EPM actual -->
          <div class="copy-desc-preview-section">
            <strong class="text-success">
              <b-icon icon="box-arrow-right" class="mr-1"></b-icon>
              {{ $t("reusable.descriptorsContainer.descriptorsToBecopied") }}
              <small class="text-muted">
                ({{ $t("reusable.descriptorsContainer.sourceLabel") }}:
                {{ currentEpmProfileName }})
              </small>
            </strong>
            <ul
              v-if="epm_descriptors_preview.length > 0"
              class="copy-desc-preview-list"
            >
              <template
                v-for="group in groupedByPagePosition(epm_descriptors_preview)"
              >
                <li
                  :key="'epm-epm-src-section-' + group.position"
                  class="descriptor-section-label"
                >
                  {{ sectionLabel(group.position) }}
                </li>
                <li
                  v-for="d in group.items"
                  :key="'epm-epm-src-' + d.id"
                  v-b-popover.hover.html.top="{
                    content:
                      d.description && d.description.trim()
                        ? d.description
                        : `<em>${$t(
                            'reusable.descriptorsContainer.noContent'
                          )}</em>`,
                    title: getDescriptorTitle(d.descriptor),
                    boundary: 'window',
                    customClass: 'descriptor-preview-popover',
                  }"
                >
                  <span>●</span>
                  {{ getDescriptorTitle(d.descriptor) }}
                </li>
              </template>
            </ul>
            <p v-else class="text-muted small mb-0">
              {{ $t("reusable.descriptorsContainer.noDescriptorsInSource") }}
            </p>
          </div>
          <!-- Destino: EPM seleccionado -->
          <div class="copy-desc-preview-section mt-2">
            <strong class="text-danger">
              <b-icon icon="trash" class="mr-1"></b-icon>
              {{ $t("reusable.descriptorsContainer.descriptorsToBeReplaced") }}
              <small class="text-muted">
                ({{ $t("reusable.descriptorsContainer.targetLabel") }}:
                {{
                  copy_target_epm_id
                    ? availableToEpmsOptions.find(
                        (o) => o.value == copy_target_epm_id
                      )
                      ? availableToEpmsOptions.find(
                          (o) => o.value == copy_target_epm_id
                        ).text
                      : "—"
                    : "—"
                }})
              </small>
            </strong>
            <div v-if="is_loading_preview" class="text-muted small py-1">
              <b-spinner small class="mr-1"></b-spinner>
              {{ $t("reusable.descriptorsContainer.loadingDescriptors") }}
            </div>
            <template v-else-if="copy_target_epm_id">
              <ul
                v-if="target_epm_descriptors_preview.length > 0"
                class="copy-desc-preview-list"
              >
                <template
                  v-for="group in groupedByPagePosition(
                    target_epm_descriptors_preview
                  )"
                >
                  <li
                    :key="'epm-epm-tgt-section-' + group.position"
                    class="descriptor-section-label"
                  >
                    {{ sectionLabel(group.position) }}
                  </li>
                  <li
                    v-for="d in group.items"
                    :key="'epm-epm-tgt-' + d.id"
                    v-b-popover.hover.html.top="{
                      content:
                        d.description && d.description.trim()
                          ? d.description
                          : `<em>${$t(
                              'reusable.descriptorsContainer.noContent'
                            )}</em>`,
                      title: getDescriptorTitle(d.descriptor),
                      boundary: 'window',
                      customClass: 'descriptor-preview-popover',
                    }"
                  >
                    <span>●</span>
                    {{ getDescriptorTitle(d.descriptor) }}
                  </li>
                </template>
              </ul>
              <p v-else class="text-muted small mb-0">
                {{ $t("reusable.descriptorsContainer.noDescriptorsInTarget") }}
              </p>
            </template>
            <p v-else class="text-muted small mb-0">—</p>
          </div>
        </div>
        <b-button
          variant="primary"
          size="sm"
          :disabled="!copy_target_epm_id || is_copying"
          @click="copyEpmToEpm"
        >
          <b-spinner v-if="is_copying" small class="mr-1"></b-spinner>
          {{ $t("reusable.descriptorsContainer.copyDescriptors") }}
        </b-button>
      </div>
    </b-modal>

    <!-- Modal EPM ← EPM (desde otro EPM al actual) -->
    <b-modal
      v-if="matter"
      :id="`${ref_component}copy-epm-from-epm-modal`"
      :title="
        $t('reusable.descriptorsContainer.copyDescriptorsFromEpm', {
          entity: $getVisibleNames(
            'mesh.egressprofilematter',
            false,
            'Asignatura'
          ),
          entity2: $getVisibleNames(
            'mesh.egressprofile',
            false,
            'Perfil de Egreso'
          ),
        })
      "
      size="lg"
      hide-footer
    >
      <div class="copy-desc-options">
        <b-alert show variant="info" class="mb-3 small">
          <b-icon icon="info-circle-fill" class="mr-1"></b-icon>
          <RenderVHtml
            class="d-inline p-0"
            :content="
              $t(
                'reusable.descriptorsContainer.copyEpmFromEpmDescriptorsDesc',
                {
                  entity: $getVisibleNames(
                    'mesh.egressprofilematter',
                    false,
                    'Asignatura'
                  ),
                  entityProfile: $getVisibleNames(
                    'mesh.egressprofile',
                    false,
                    'Perfil de Egreso'
                  ),
                }
              )
            "
          ></RenderVHtml>
        </b-alert>
        <b-form-select
          v-model="copy_source_epm_id"
          :options="availableFromEpmsOptions"
          size="sm"
          class="mb-3"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>
              {{
                $t("reusable.descriptorsContainer.selectSourceEpm", {
                  entity: $getVisibleNames(
                    "mesh.egressprofilematter",
                    false,
                    "Asignatura"
                  ),
                })
              }}
            </b-form-select-option>
          </template>
        </b-form-select>
        <div class="copy-desc-preview-container mb-3">
          <!-- Origen: EPM seleccionado (se copiará) -->
          <div class="copy-desc-preview-section">
            <strong class="text-success">
              <b-icon icon="box-arrow-right" class="mr-1"></b-icon>
              {{ $t("reusable.descriptorsContainer.descriptorsToBecopied") }}
              <small class="text-muted">
                ({{ $t("reusable.descriptorsContainer.sourceLabel") }}:
                {{
                  copy_source_epm_id
                    ? availableFromEpmsOptions.find(
                        (o) => o.value == copy_source_epm_id
                      )
                      ? availableFromEpmsOptions.find(
                          (o) => o.value == copy_source_epm_id
                        ).text
                      : "—"
                    : "—"
                }})
              </small>
            </strong>
            <div v-if="is_loading_source_preview" class="text-muted small py-1">
              <b-spinner small class="mr-1"></b-spinner>
              {{ $t("reusable.descriptorsContainer.loadingDescriptors") }}
            </div>
            <template v-else-if="copy_source_epm_id">
              <ul
                v-if="source_epm_descriptors_preview.length > 0"
                class="copy-desc-preview-list"
              >
                <template
                  v-for="group in groupedByPagePosition(
                    source_epm_descriptors_preview
                  )"
                >
                  <li
                    :key="'epm-from-epm-src-section-' + group.position"
                    class="descriptor-section-label"
                  >
                    {{ sectionLabel(group.position) }}
                  </li>
                  <li
                    v-for="d in group.items"
                    :key="'epm-from-epm-src-' + d.id"
                    v-b-popover.hover.html.top="{
                      content:
                        d.description && d.description.trim()
                          ? d.description
                          : `<em>${$t(
                              'reusable.descriptorsContainer.noContent'
                            )}</em>`,
                      title: getDescriptorTitle(d.descriptor),
                      boundary: 'window',
                      customClass: 'descriptor-preview-popover',
                    }"
                  >
                    <span>●</span>
                    {{ getDescriptorTitle(d.descriptor) }}
                  </li>
                </template>
              </ul>
              <p v-else class="text-muted small mb-0">
                {{ $t("reusable.descriptorsContainer.noDescriptorsInSource") }}
              </p>
            </template>
            <p v-else class="text-muted small mb-0">—</p>
          </div>
          <!-- Destino: EPM actual (se reemplazará) -->
          <div class="copy-desc-preview-section mt-2">
            <strong class="text-danger">
              <b-icon icon="trash" class="mr-1"></b-icon>
              {{ $t("reusable.descriptorsContainer.descriptorsToBeReplaced") }}
              <small class="text-muted">
                ({{ $t("reusable.descriptorsContainer.targetLabel") }}:
                {{ currentEpmProfileName }})
              </small>
            </strong>
            <ul
              v-if="epm_descriptors_preview.length > 0"
              class="copy-desc-preview-list"
            >
              <template
                v-for="group in groupedByPagePosition(epm_descriptors_preview)"
              >
                <li
                  :key="'epm-from-epm-tgt-section-' + group.position"
                  class="descriptor-section-label"
                >
                  {{ sectionLabel(group.position) }}
                </li>
                <li
                  v-for="d in group.items"
                  :key="'epm-from-epm-tgt-' + d.id"
                  v-b-popover.hover.html.top="{
                    content:
                      d.description && d.description.trim()
                        ? d.description
                        : `<em>${$t(
                            'reusable.descriptorsContainer.noContent'
                          )}</em>`,
                    title: getDescriptorTitle(d.descriptor),
                    boundary: 'window',
                    customClass: 'descriptor-preview-popover',
                  }"
                >
                  <span>●</span>
                  {{ getDescriptorTitle(d.descriptor) }}
                </li>
              </template>
            </ul>
            <p v-else class="text-muted small mb-0">
              {{ $t("reusable.descriptorsContainer.noDescriptorsInTarget") }}
            </p>
          </div>
        </div>
        <b-button
          variant="primary"
          size="sm"
          :disabled="!copy_source_epm_id || is_copying"
          @click="copyEpmFromEpm"
        >
          <b-spinner v-if="is_copying" small class="mr-1"></b-spinner>
          {{ $t("reusable.descriptorsContainer.copyDescriptors") }}
        </b-button>
      </div>
    </b-modal>

    <!-- Modal EPM → Matter -->
    <b-modal
      v-if="matter"
      :id="`${ref_component}copy-epm-to-matter-modal`"
      :title="
        $t('reusable.descriptorsContainer.copyDescriptorsToMatter', {
          entityMatter: $getVisibleNames(
            'teaching.matter',
            false,
            'Asignatura Base'
          ),
        })
      "
      size="lg"
      hide-footer
    >
      <div class="copy-desc-options">
        <b-alert show variant="warning" class="mb-3 small">
          <b-icon icon="exclamation-triangle-fill" class="mr-1"></b-icon>
          {{
            $t("reusable.descriptorsContainer.copyEpmToMatterDescriptorsDesc", {
              entity: $getVisibleNames(
                "mesh.egressprofilematter",
                false,
                "Asignatura"
              ),
              entityMatter: $getVisibleNames(
                "teaching.matter",
                false,
                "Asignatura Base"
              ),
              entityEpm: $getVisibleNames(
                "mesh.egressprofilematter",
                true,
                "Asignaturas"
              ),
            })
          }}
        </b-alert>
        <div class="copy-desc-preview-container mb-3">
          <div class="copy-desc-preview-section">
            <strong class="text-success">
              <b-icon icon="box-arrow-right" class="mr-1"></b-icon>
              {{ $t("reusable.descriptorsContainer.descriptorsToBecopied") }}
              <small class="text-muted">
                ({{ $t("reusable.descriptorsContainer.sourceLabel") }}:
                {{ currentEpmProfileName }})
              </small>
            </strong>
            <ul
              v-if="epm_descriptors_preview.length > 0"
              class="copy-desc-preview-list"
            >
              <template
                v-for="group in groupedByPagePosition(epm_descriptors_preview)"
              >
                <li
                  :key="'epm-mat-src-section-' + group.position"
                  class="descriptor-section-label"
                >
                  {{ sectionLabel(group.position) }}
                </li>
                <li
                  v-for="d in group.items"
                  :key="'epm-mat-src-' + d.id"
                  v-b-popover.hover.html.top="{
                    content:
                      d.description && d.description.trim()
                        ? d.description
                        : `<em>${$t(
                            'reusable.descriptorsContainer.noContent'
                          )}</em>`,
                    title: getDescriptorTitle(d.descriptor),
                    boundary: 'window',
                    customClass: 'descriptor-preview-popover',
                  }"
                >
                  <span>●</span>
                  {{ getDescriptorTitle(d.descriptor) }}
                </li>
              </template>
            </ul>
            <p v-else class="text-muted small mb-0">
              {{ $t("reusable.descriptorsContainer.noDescriptorsInSource") }}
            </p>
          </div>
          <div class="copy-desc-preview-section mt-2">
            <strong class="text-danger">
              <b-icon icon="trash" class="mr-1"></b-icon>
              {{ $t("reusable.descriptorsContainer.descriptorsToBeReplaced") }}
              <small class="text-muted">
                ({{ $t("reusable.descriptorsContainer.targetLabel") }}:
                {{
                  $getVisibleNames("teaching.matter", false, "Asignatura Base")
                }})
              </small>
            </strong>
            <ul
              v-if="matter_descriptors_preview.length > 0"
              class="copy-desc-preview-list"
            >
              <template
                v-for="group in groupedByPagePosition(
                  matter_descriptors_preview
                )"
              >
                <li
                  :key="'epm-mat-tgt-section-' + group.position"
                  class="descriptor-section-label"
                >
                  {{ sectionLabel(group.position) }}
                </li>
                <li
                  v-for="d in group.items"
                  :key="'epm-mat-tgt-' + d.id"
                  v-b-popover.hover.html.top="{
                    content:
                      d.description && d.description.trim()
                        ? d.description
                        : `<em>${$t(
                            'reusable.descriptorsContainer.noContent'
                          )}</em>`,
                    title: getDescriptorTitle(d.descriptor),
                    boundary: 'window',
                    customClass: 'descriptor-preview-popover',
                  }"
                >
                  <span>●</span>
                  {{ getDescriptorTitle(d.descriptor) }}
                </li>
              </template>
            </ul>
            <p v-else class="text-muted small mb-0">
              {{ $t("reusable.descriptorsContainer.noDescriptorsInTarget") }}
            </p>
          </div>
        </div>
        <b-button
          variant="primary"
          size="sm"
          :disabled="is_copying"
          @click="copyEpmToMatter"
        >
          <b-spinner v-if="is_copying" small class="mr-1"></b-spinner>
          {{ $t("reusable.descriptorsContainer.copyDescriptors") }}
        </b-button>
      </div>
    </b-modal>

    <!-- Modal Matter → EPM -->
    <b-modal
      v-if="matter"
      :id="`${ref_component}copy-matter-to-epm-modal`"
      :title="
        $t('reusable.descriptorsContainer.copyDescriptorsFromMatter', {
          entityMatter: $getVisibleNames(
            'teaching.matter',
            false,
            'Asignatura Base'
          ),
        })
      "
      size="lg"
      hide-footer
    >
      <div class="copy-desc-options">
        <b-alert show variant="info" class="mb-3 small">
          <b-icon icon="info-circle-fill" class="mr-1"></b-icon>
          {{
            $t("reusable.descriptorsContainer.copyMatterToEpmDescriptorsDesc", {
              entity: $getVisibleNames(
                "mesh.egressprofilematter",
                false,
                "Asignatura"
              ),
              entityMatter: $getVisibleNames(
                "teaching.matter",
                false,
                "Asignatura Base"
              ),
            })
          }}
        </b-alert>
        <div class="copy-desc-preview-container mb-3">
          <!-- Origen: Asignatura Base -->
          <div class="copy-desc-preview-section">
            <strong class="text-success">
              <b-icon icon="box-arrow-right" class="mr-1"></b-icon>
              {{ $t("reusable.descriptorsContainer.descriptorsToBecopied") }}
              <small class="text-muted">
                ({{ $t("reusable.descriptorsContainer.sourceLabel") }}:
                {{
                  $getVisibleNames("teaching.matter", false, "Asignatura Base")
                }})
              </small>
            </strong>
            <ul
              v-if="matter_descriptors_preview.length > 0"
              class="copy-desc-preview-list"
            >
              <template
                v-for="group in groupedByPagePosition(
                  matter_descriptors_preview
                )"
              >
                <li
                  :key="'mat-epm-src-section-' + group.position"
                  class="descriptor-section-label"
                >
                  {{ sectionLabel(group.position) }}
                </li>
                <li
                  v-for="d in group.items"
                  :key="'mat-epm-src-' + d.id"
                  v-b-popover.hover.html.top="{
                    content:
                      d.description && d.description.trim()
                        ? d.description
                        : `<em>${$t(
                            'reusable.descriptorsContainer.noContent'
                          )}</em>`,
                    title: getDescriptorTitle(d.descriptor),
                    boundary: 'window',
                    customClass: 'descriptor-preview-popover',
                  }"
                >
                  <span>●</span>
                  {{ getDescriptorTitle(d.descriptor) }}
                </li>
              </template>
            </ul>
            <p v-else class="text-muted small mb-0">
              {{ $t("reusable.descriptorsContainer.noDescriptorsInSource") }}
            </p>
          </div>
          <!-- Destino: EPM actual -->
          <div class="copy-desc-preview-section mt-2">
            <strong class="text-danger">
              <b-icon icon="trash" class="mr-1"></b-icon>
              {{ $t("reusable.descriptorsContainer.descriptorsToBeReplaced") }}
              <small class="text-muted">
                ({{ $t("reusable.descriptorsContainer.targetLabel") }}:
                {{ currentEpmProfileName }})
              </small>
            </strong>
            <ul
              v-if="epm_descriptors_preview.length > 0"
              class="copy-desc-preview-list"
            >
              <template
                v-for="group in groupedByPagePosition(epm_descriptors_preview)"
              >
                <li
                  :key="'mat-epm-tgt-section-' + group.position"
                  class="descriptor-section-label"
                >
                  {{ sectionLabel(group.position) }}
                </li>
                <li
                  v-for="d in group.items"
                  :key="'mat-epm-tgt-' + d.id"
                  v-b-popover.hover.html.top="{
                    content:
                      d.description && d.description.trim()
                        ? d.description
                        : `<em>${$t(
                            'reusable.descriptorsContainer.noContent'
                          )}</em>`,
                    title: getDescriptorTitle(d.descriptor),
                    boundary: 'window',
                    customClass: 'descriptor-preview-popover',
                  }"
                >
                  <span>●</span>
                  {{ getDescriptorTitle(d.descriptor) }}
                </li>
              </template>
            </ul>
            <p v-else class="text-muted small mb-0">
              {{ $t("reusable.descriptorsContainer.noDescriptorsInTarget") }}
            </p>
          </div>
        </div>
        <b-button
          variant="primary"
          size="sm"
          :disabled="is_copying"
          @click="copyMatterToEpm"
        >
          <b-spinner v-if="is_copying" small class="mr-1"></b-spinner>
          {{ $t("reusable.descriptorsContainer.copyDescriptors") }}
        </b-button>
      </div>
    </b-modal>

    <div>
      <ButtonMedium
        v-if="allows_crud && show_add_button && can_update"
        :tooltip_text="``"
        :custom_class="`my-2`"
        :click_button="() => $bvModal.show(`${ref_component}title-modal`)"
        :text_button="$t('reusable.descriptorsContainer.addDescriptor')"
        :icon="'plus'"
        :variant="'primary'"
      >
      </ButtonMedium>
      <!-- <b-button
        v-if="allows_crud && show_add_button"
        size="sm"
        class="secondary-button my-2"
        @click="$bvModal.show(`${ref_component}title-modal`)"
        ><b-icon-plus></b-icon-plus>Agregar Descriptor</b-button
      > -->
      <b-button
        v-if="PagePosition == 2 && ref_component == 'EgressProfileDescriptor2'"
        variant="secondary"
        size="sm"
        class="secondary-button my-2 ml-3 noprint"
        @click="$bvModal.show('egressprofile-file-modal')"
      >
        {{ $t("reusable.descriptorsContainer.attachments") }}
      </b-button>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import { generateUniqueId } from "@/utils/utils";
import {
  // generateUniqueId,
  toast,
} from "@/utils/utils";

export default {
  name: "DescriptorsContainer",
  components: {
    draggable,
    TextArea: () => import("@/components/reusable/TextArea"),
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    InfoTooltip: () => import("@/components/reusable/InfoTooltip"),
    MethodologicalStrategyTable: () =>
      import(
        "@/components/teaching/MatterProgram/Components/MethodologicalStrategyTable"
      ),
    DuocSpecialDescriptor: () =>
      import("@/components/mesh/Matrix2/DuocSpecialDescriptor"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    ContainerButtonsDownload: () =>
      import("@/components/reusable/Buttons/ContainerButtonsDownload"),
  },
  props: {
    ref_component: {
      type: String,
      default: "",
    },
    Title: {
      type: Array,
    },
    Descriptors: {
      type: Array,
    },
    Title_text: {
      type: String,
      default: "",
    },
    Text_info_tooltip: {
      type: String,
      default: "",
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
    show_add_button: {
      type: Boolean,
      default: true,
    },
    // Nombre de grupo de Sortable compartido entre contenedores: permite
    // arrastrar un contenido a otro apartado (el padre maneja moveToSection)
    drag_group: {
      type: String,
      default: null,
    },
    Order: {
      type: Number,
      default: 1,
    },
    PagePosition: {
      type: Number,
      default: 1,
    },
    VisibleOrder: {
      type: Boolean,
      default: false,
    },
    ProgramView: {
      type: Boolean,
      default: false,
    },
    show_is_default: {
      type: Boolean,
      default: true,
    },
    show_visible: {
      type: Boolean,
      default: true,
    },
    rich_text_editor: {
      type: Boolean,
      default: true,
    },
    show_matter_descriptor: {
      type: Boolean,
      default: false,
    },
    // Necesario para renderizar el componente MethodologicalStrategyTable que va a ser mostrado arriba del descriptor con internal_use_id = duoc_pmd_methodological_strategy
    matter: {
      type: Object,
      default: null,
    },
    // Necesario para restringir los descriptores duoc_pmd_te_evaluation_situation, duoc_pmd_te_orientations,duoc_pmd_matter_description_superior, duoc_pmd_outside_activities_indications cuando se cierre el candado.
    oldMatter: {
      type: Object,
      default: null,
    },
    can_delete: {
      type: Boolean,
      default: false,
    },
    can_update: {
      type: Boolean,
      default: false,
    },
    // Borrar un título afecta a todas las entidades que lo usan; el padre puede restringirlo
    // globalmente (Boolean) o por título (Function: item => Boolean)
    can_delete_title: {
      type: [Boolean, Function],
      default: true,
    },
  },
  data() {
    return {
      title_proccess: {
        id: generateUniqueId(),
        title: "",
        page_position: this.PagePosition,
        is_default: true,
        internal_use_id: null,
      },
      // Copy descriptors
      epm_to_targets: [],
      epm_from_sources: [],
      is_fetching_sources: false,
      copy_target_epm_id: null,
      copy_source_epm_id: null,
      target_epm_descriptors_preview: [],
      source_epm_descriptors_preview: [],
      is_loading_preview: false,
      is_loading_source_preview: false,
      is_copying: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      formation_lines: names.FORMATION_LINES,
      egressProfiles: names.EGRESS_PROFILES,
      epm_middle_descriptors: names.EPM_MIDDLE_DESCRIPTORS,
      egress_profile_matter_descriptors:
        names.EGRESS_PROFILE_MATTER_DESCRIPTORS,
      m_middle_descriptors: names.M_MIDDLE_DESCRIPTORS,
    }),
    all_descriptor_titles() {
      return this.egress_profile_matter_descriptors;
    },
    epm_descriptors_preview() {
      if (!this.matter) return [];
      return this.epm_middle_descriptors
        .filter((x) => x.egress_profile_matter == this.matter.id)
        .sort((a, b) => a.order - b.order);
    },
    matter_descriptors_preview() {
      if (!this.matter) return [];
      return this.m_middle_descriptors
        .filter((x) => x.matter == this.matter.matter)
        .sort((a, b) => a.order - b.order);
    },
    shouldFetchCopySources() {
      return (
        this.matter &&
        !this.matter.use_matter_values &&
        this.allows_crud &&
        this.can_update &&
        this.PagePosition == 1 && // Para que se vea en la aprte superior
        this.institution &&
        this.institution.internal_use_id != "duoc.cl" &&
        this.user &&
        this.user.is_superuser
      );
    },
    availableToEpmsOptions() {
      return this.epm_to_targets.map((epm) => ({
        value: epm.egress_profile_matter,
        text: epm.name || `ID: ${epm.egress_profile_matter}`,
      }));
    },
    availableFromEpmsOptions() {
      return this.epm_from_sources.map((epm) => ({
        value: epm.egress_profile_matter,
        text: epm.name || `ID: ${epm.egress_profile_matter}`,
      }));
    },
    currentEpmProfileName() {
      if (!this.matter) return "";
      const profile = this.egressProfiles.find(
        (p) => p.id == this.matter.egress_profile
      );
      return profile ? profile.professional_title || profile.name : "";
    },
    myList: {
      get() {
        let list = this.Descriptors;
        list.sort(function (a, b) {
          if (a.order < b.order) return -1;
          if (a.order > b.order) return 1;
          return 0;
        });
        return list;
      },
      set(list) {
        // Arrastre entre apartados (drag_group): el que pierde el contenido no
        // reordena y el que lo recibe delega al padre, que confirma antes de
        // guardar; mientras tanto la lista se queda como estaba
        if (list.length < this.Descriptors.length) return;
        const incoming = list.find(
          (x) => !this.Title.some((t) => t.id == x.descriptor)
        );
        if (incoming) {
          this.$emit("moveToSection", incoming, list);
          return;
        }
        let order = this.Order;
        list.forEach((element) => {
          if (element.order != order) element.order = order;
          order += 1;
        });
        this.$emit("updateOrder", list);
      },
    },
    showDropZone() {
      return (
        !!this.drag_group &&
        this.allows_crud &&
        this.can_update &&
        this.myList.length == 0
      );
    },
    getFormationLineDescription() {
      if (!this.matter) return null;
      const matter_formation_line = this.formation_lines.find(
        (x) => this.matter.formation_line == x.id
      );
      return matter_formation_line ? matter_formation_line.description : null;
    },
  },
  watch: {
    copy_target_epm_id(newVal) {
      if (newVal) this.fetchTargetEpmDescriptors(newVal);
      else this.target_epm_descriptors_preview = [];
    },
    copy_source_epm_id(newVal) {
      if (newVal) this.fetchSourceEpmDescriptors(newVal);
      else this.source_epm_descriptors_preview = [];
    },
    shouldFetchCopySources(newVal) {
      if (
        newVal &&
        this.epm_to_targets.length === 0 &&
        !this.is_fetching_sources
      ) {
        this.fetchCopySources();
      }
    },
  },
  methods: {
    isClosedOldMatterPartial(internal_use_id) {
      if (this.oldMatter) {
        if (this.institution && this.institution.internal_use_id == "duoc.cl") {
          if (
            this.$equals(internal_use_id, "duoc_pmd_te_evaluation_situation") ||
            this.$equals(internal_use_id, "duoc_pmd_te_orientations") ||
            this.$equals(
              internal_use_id,
              "duoc_pmd_matter_description_superior"
            ) ||
            this.$equals(internal_use_id, "duoc_key_suggestions_and_warnings")
          ) {
            return !this.oldMatter.descriptors_locked_view;
          } else return true;
        } else {
          return !this.oldMatter.descriptors_locked_view;
        }
      } else return true;
    },
    showDescriptor(item) {
      this.$emit("updateState", item);
    },
    slotUpdatedTitle(item) {
      this.title_proccess.id = item.id;
      this.title_proccess.title = item.title;
      this.title_proccess.is_default = item.is_default;
      if (item.internal_use_id != null)
        this.title_proccess.internal_use_id = item.internal_use_id;
      this.$bvModal.show(`${this.ref_component}title-modal`);
    },
    resetTitleModal() {
      this.title_proccess.id = generateUniqueId();
      this.title_proccess.title = "";
      this.title_proccess.is_default = false;
      this.title_proccess.internal_use_id = null;
    },
    updateDescription(object, text) {
      this.$emit("updateDescription", object, text);
    },
    save(title) {
      title.page_position = this.PagePosition;
      if (isNaN(title.id)) {
        title.internal_use_id = null;
        this.$emit("createTitle", title);
        this.$bvModal.hide(`${this.ref_component}title-modal`);
      } else {
        this.$swal({
          title: this.$t("reusable.descriptorsContainer.editDescriptorConfirm"),
          text: `"${this.$t(
            "reusable.descriptorsContainer.affectOthersWarning",
            { entity: this.Title_text }
          )}"`,
          type: "warning",
          showCancelButton: true,
        }).then((result) => {
          if (result.value) {
            this.$emit("updateTitle", title);
            this.$bvModal.hide(`${this.ref_component}title-modal`);
          }
        });
      }
    },
    deleteDescriptors(item) {
      if (item) {
        if (!isNaN(item.id) && !isNaN(item.descriptor)) {
          this.$emit("deleteDescriptors", item);
        }
      }
    },
    canDeleteTitle(item) {
      if (typeof this.can_delete_title === "function")
        return this.can_delete_title(item);
      return this.can_delete_title;
    },
    deleteTitle(item) {
      // Mostrar todos los objetos que se van a eliminar.
      if (!isNaN(item.id)) {
        this.$emit("deleteTitle", item);
      }
    },
    createDescription(text, object) {
      this.$emit("createDescription", text, object);
    },
    // Programa de asignatura: 1 = arriba, 2 = entre RA y evaluaciones,
    // 3 = después de las evaluaciones, 4 = después de los recursos del
    // ambiente de aprendizaje, 5 = al final
    sectionLabel(position) {
      const keys = {
        1: "sectionTop",
        2: "sectionMiddle",
        3: "sectionAfterEvaluations",
        4: "sectionAfterLearningEnv",
      };
      return this.$t(
        `reusable.descriptorsContainer.${keys[position] || "sectionBottom"}`
      );
    },
    getDescriptorPagePosition(descriptorId) {
      const found =
        this.all_descriptor_titles.find((x) => x.id == descriptorId) ||
        (this.Title ? this.Title.find((x) => x.id == descriptorId) : null);
      return found ? found.page_position : 1;
    },
    groupedByPagePosition(list) {
      const groups = {};
      list.forEach((d) => {
        const pos = this.getDescriptorPagePosition(d.descriptor);
        if (!groups[pos]) groups[pos] = [];
        groups[pos].push(d);
      });
      return Object.keys(groups)
        .sort()
        .map((pos) => ({ position: parseInt(pos), items: groups[pos] }));
    },
    getDescriptorTitle(descriptorId) {
      const found =
        this.all_descriptor_titles.find((x) => x.id == descriptorId) ||
        (this.Title ? this.Title.find((x) => x.id == descriptorId) : null);
      return found ? found.title : `#${descriptorId}`;
    },
    stripHtmlPreview(html) {
      if (!html || !html.trim()) return "";
      const stripped = html
        .replace(/<[^>]+>/g, " ")
        .replace(/\s+/g, " ")
        .trim();
      return stripped.length > 150
        ? stripped.substring(0, 150) + "..."
        : stripped;
    },
    fetchCopySources() {
      if (!this.matter || this.is_fetching_sources) return;
      this.is_fetching_sources = true;
      this.$restful
        .Post(
          `/mesh/epm_copy_sources/?egress_profile_matter=${this.matter.id}`,
          {}
        )
        .then((response) => {
          this.epm_to_targets = response.all_epms || [];
          this.epm_from_sources = response.epms_with_descriptors || [];
        })
        .finally(() => {
          this.is_fetching_sources = false;
        });
    },
    fetchTargetEpmDescriptors(epmId) {
      this.is_loading_preview = true;
      this.target_epm_descriptors_preview = [];
      this.$restful
        .GetAll(`/mesh/epm-middle-descriptor/?egress_profile_matter=${epmId}`)
        .then((response) => {
          this.target_epm_descriptors_preview = response.sort(
            (a, b) => a.order - b.order
          );
        })
        .finally(() => {
          this.is_loading_preview = false;
        });
    },
    fetchSourceEpmDescriptors(epmId) {
      this.is_loading_source_preview = true;
      this.source_epm_descriptors_preview = [];
      this.$restful
        .GetAll(`/mesh/epm-middle-descriptor/?egress_profile_matter=${epmId}`)
        .then((response) => {
          this.source_epm_descriptors_preview = response.sort(
            (a, b) => a.order - b.order
          );
        })
        .finally(() => {
          this.is_loading_source_preview = false;
        });
    },
    openEpmToEpmModal() {
      if (this.matter && this.matter.matter) {
        this.$store.dispatch(names.FETCH_EGRESS_PROFILE_MATTER_DESCRIPTORS, {
          matter_id: this.matter.matter,
        });
      }
      this.copy_target_epm_id = null;
      this.target_epm_descriptors_preview = [];
      this.$bvModal.show(`${this.ref_component}copy-epm-to-epm-modal`);
    },
    openEpmFromEpmModal() {
      if (this.matter && this.matter.matter) {
        this.$store.dispatch(names.FETCH_EGRESS_PROFILE_MATTER_DESCRIPTORS, {
          matter_id: this.matter.matter,
        });
      }
      this.copy_source_epm_id = null;
      this.source_epm_descriptors_preview = [];
      this.$bvModal.show(`${this.ref_component}copy-epm-from-epm-modal`);
    },
    openEpmToMatterModal() {
      if (this.matter && this.matter.matter) {
        this.$store.dispatch(names.FETCH_EGRESS_PROFILE_MATTER_DESCRIPTORS, {
          matter_id: this.matter.matter,
        });
      }
      this.$bvModal.show(`${this.ref_component}copy-epm-to-matter-modal`);
    },
    openMatterToEpmModal() {
      if (this.matter && this.matter.matter) {
        this.$store.dispatch(names.FETCH_EGRESS_PROFILE_MATTER_DESCRIPTORS, {
          matter_id: this.matter.matter,
        });
      }
      this.$bvModal.show(`${this.ref_component}copy-matter-to-epm-modal`);
    },
    copyEpmToEpm() {
      if (!this.copy_target_epm_id) return;
      this.$bvModal
        .msgBoxConfirm(
          this.$t("reusable.descriptorsContainer.copyDescriptorsConfirm"),
          {
            title: this.$t("reusable.descriptorsContainer.copyDescriptors"),
            size: "md",
            buttonSize: "md",
            okVariant: "danger",
            okTitle: this.$t("reusable.descriptorsContainer.copyDescriptors"),
            cancelTitle: this.$t("reusable.common.cancel"),
            centered: true,
          }
        )
        .then((confirmed) => {
          if (!confirmed) return;
          this.is_copying = true;
          this.$restful
            .Post("/mesh/copy_epm_descriptors_to_epm/", {
              source_epm_id: this.matter.id,
              target_epm_id: this.copy_target_epm_id,
            })
            .then(() => {
              toast(
                this.$t("reusable.descriptorsContainer.copyDescriptorsSuccess")
              );
              this.$bvModal.hide(`${this.ref_component}copy-epm-to-epm-modal`);
            })
            .catch(() => {
              toast(
                this.$t("reusable.descriptorsContainer.copyDescriptorsError")
              );
            })
            .finally(() => {
              this.is_copying = false;
            });
        });
    },
    copyEpmFromEpm() {
      if (!this.copy_source_epm_id) return;
      this.$bvModal
        .msgBoxConfirm(
          this.$t("reusable.descriptorsContainer.copyDescriptorsConfirm"),
          {
            title: this.$t("reusable.descriptorsContainer.copyDescriptors"),
            size: "md",
            buttonSize: "md",
            okVariant: "danger",
            okTitle: this.$t("reusable.descriptorsContainer.copyDescriptors"),
            cancelTitle: this.$t("reusable.common.cancel"),
            centered: true,
          }
        )
        .then((confirmed) => {
          if (!confirmed) return;
          this.is_copying = true;
          this.$restful
            .Post("/mesh/copy_epm_descriptors_to_epm/", {
              source_epm_id: this.copy_source_epm_id,
              target_epm_id: this.matter.id,
            })
            .then(() => {
              toast(
                this.$t("reusable.descriptorsContainer.copyDescriptorsSuccess")
              );
              this.$bvModal.hide(
                `${this.ref_component}copy-epm-from-epm-modal`
              );
              this.refreshEpmDescriptors();
            })
            .catch(() => {
              toast(
                this.$t("reusable.descriptorsContainer.copyDescriptorsError")
              );
            })
            .finally(() => {
              this.is_copying = false;
            });
        });
    },
    copyEpmToMatter() {
      this.$bvModal
        .msgBoxConfirm(
          this.$t("reusable.descriptorsContainer.copyDescriptorsConfirm"),
          {
            title: this.$t("reusable.descriptorsContainer.copyDescriptors"),
            size: "md",
            buttonSize: "md",
            okVariant: "danger",
            okTitle: this.$t("reusable.descriptorsContainer.copyDescriptors"),
            cancelTitle: this.$t("reusable.common.cancel"),
            centered: true,
          }
        )
        .then((confirmed) => {
          if (!confirmed) return;
          this.is_copying = true;
          this.$restful
            .Post("/mesh/copy_epm_descriptors_to_matter/", {
              source_epm_id: this.matter.id,
            })
            .then(() => {
              toast(
                this.$t("reusable.descriptorsContainer.copyDescriptorsSuccess")
              );
              this.$bvModal.hide(
                `${this.ref_component}copy-epm-to-matter-modal`
              );
            })
            .catch(() => {
              toast(
                this.$t("reusable.descriptorsContainer.copyDescriptorsError")
              );
            })
            .finally(() => {
              this.is_copying = false;
            });
        });
    },
    copyMatterToEpm() {
      this.$bvModal
        .msgBoxConfirm(
          this.$t("reusable.descriptorsContainer.copyDescriptorsConfirm"),
          {
            title: this.$t("reusable.descriptorsContainer.copyDescriptors"),
            size: "md",
            buttonSize: "md",
            okVariant: "danger",
            okTitle: this.$t("reusable.descriptorsContainer.copyDescriptors"),
            cancelTitle: this.$t("reusable.common.cancel"),
            centered: true,
          }
        )
        .then((confirmed) => {
          if (!confirmed) return;
          this.is_copying = true;
          this.$restful
            .Post("/mesh/copy_matter_descriptors_to_epm/", {
              target_epm_id: this.matter.id,
            })
            .then(() => {
              toast(
                this.$t("reusable.descriptorsContainer.copyDescriptorsSuccess")
              );
              this.$bvModal.hide(
                `${this.ref_component}copy-matter-to-epm-modal`
              );
              this.refreshEpmDescriptors();
            })
            .catch(() => {
              toast(
                this.$t("reusable.descriptorsContainer.copyDescriptorsError")
              );
            })
            .finally(() => {
              this.is_copying = false;
            });
        });
    },
    refreshEpmDescriptors() {
      if (!this.matter) return;
      // Paso 1: recargar los EgressProfileMatterDescriptor (títulos) para que
      // los nuevos IDs replicados por el backend existan en el store.
      this.$store
        .dispatch(names.FETCH_EGRESS_PROFILE_MATTER_DESCRIPTORS, {
          matter_id: this.matter.matter,
        })
        .then(() => {
          // Paso 2: recargar los EPMMiddleDescriptors del EPM actual.
          return this.$store.dispatch(names.FETCH_EPM_MIDDLE_DESCRIPTORS, {
            egress_profile_matter_id: this.matter.id,
          });
        })
        .then((newItems) => {
          // Paso 3: eliminar del store los EPMMiddleDescriptors stale
          // (los que ya no existen en el backend tras la operación de copia).
          const newIds = new Set(newItems.map((x) => x.id));
          this.epm_middle_descriptors
            .filter(
              (x) =>
                x.egress_profile_matter == this.matter.id && !newIds.has(x.id)
            )
            .forEach((d) => {
              this.$store.commit(
                names.MUTATE_DELETE_EPM_MIDDLE_DESCRIPTORS,
                d.id
              );
            });
        });
    },
  },
  created() {
    if (this.shouldFetchCopySources) {
      this.$nextTick(() => this.fetchCopySources());
    }
  },
};
</script>

<style scoped>
.grabbing * {
  cursor: grabbing !important;
}
.question-move {
  background-color: transparent;
  width: 25px;
  position: absolute;
  left: 20px;
}
.question-move:hover {
  color: var(--kl-text-on-primary);
}
.move-icon {
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}
.move-icon:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
.program-alter-container {
  padding-inline: 0;
}
.descriptor-order {
  float: left;
  padding-block: 0.3em;
  padding-inline: 7vh;
  border-right: 1px solid var(--kl-table-border);
  transform: translateY(-15%);
}
.descriptor-title {
  background-color: var(--kl-color-accent-medium) !important;
  padding-block: 0.3em;
  color: var(--kl-text-on-primary) !important;
  font-weight: var(--kl-fw-bold);
}
.custom-title {
  margin-left: -10vh;
}
.descriptor-body {
  display: block;
  text-align: justify;
  padding: 0.4em;
  padding-inline: 1em;
  font-size: var(--secondary-font-size);
}
.descriptor-body >>> p {
  margin-bottom: 0 !important;
}
.btn-center {
  display: flex;
  justify-content: center !important;
  margin-inline: auto !important;
}
.outlined-lr-div-secondary {
  border-inline: 1px solid var(--kl-table-border) !important;
}
.outlined-lr-div-black {
  border-inline: 1px solid var(--kl-table-border) !important;
}
.outlined-tlr-div-black {
  border: 1px solid var(--kl-table-border) !important;
}
.outlined-div-black {
  border: 1px solid var(--kl-table-border) !important;
}
.outlined-div-secondary {
  border: 1px solid var(--kl-table-border);
}
.border-bottom-black {
  border-bottom: 1px solid var(--kl-table-border) !important;
}
.border-bottom-secondary {
  border-bottom: 1px solid var(--kl-table-border) !important;
}
.selection-info {
  transform: translate(10%, -60%);
  width: 12px;
  height: 12px;
}
.descriptor-wrapper {
  position: relative;
}
.descriptor-drop-zone {
  display: block;
  min-height: 3.5rem;
  margin-bottom: 0.5rem;
  border: 2px dashed var(--kl-color-accent-border);
  border-radius: var(--kl-radius-md);
  background-color: var(--kl-surface-muted);
}
.descriptor-drop-zone:empty {
  display: flex;
  align-items: center;
  justify-content: center;
}
.descriptor-drop-zone:empty::before {
  content: attr(data-empty-text);
  color: var(--kl-text-muted);
  font-size: var(--secondary-font-size);
  font-style: italic;
}
@media print {
  .descriptor-drop-zone {
    display: none !important;
  }
}
@media print {
  .descriptor-wrapper {
    break-inside: avoid;
    page-break-inside: avoid;
  }
}
.hidden-descriptor {
  opacity: 0.5;
  border: 2px dashed #ff9800 !important;
  background-color: #fff3e0;
}
.hidden-badge {
  position: absolute;
  top: -10px;
  left: 10px;
  background-color: #ff9800;
  color: white;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 0.75rem;
  font-weight: bold;
  z-index: 10;
}
@media (max-width: 991px) {
  .selection-info {
    transform: translate(0%, -100%);
  }
}
@media (max-width: 450px) {
  .descriptor-title-check {
    margin-left: 1em;
  }
}
.descriptor-copy-buttons {
  gap: 0.25rem;
}
.copy-desc-options {
  padding: 0.5rem;
}
.copy-desc-preview-container {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  padding: 0.75rem;
}
.copy-desc-preview-section {
  margin-bottom: 0.25rem;
}
.copy-desc-preview-list {
  list-style: none;
  padding-left: 1rem;
  margin-top: 0.35rem;
  margin-bottom: 0.25rem;
}
.copy-desc-preview-list li {
  padding: 0.1rem 0;
  font-size: 0.875rem;
  cursor: default;
}
.copy-desc-preview-list li span {
  margin-right: 0.4rem;
  font-size: 0.7rem;
}
.descriptor-section-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6c757d;
  border-bottom: 1px solid #dee2e6;
  cursor: default !important;
}
.descriptor-section-label:first-child {
  margin-top: 0.1rem;
}
</style>

<style>
/* Popover de preview de descriptores — sin scoped porque Bootstrap-Vue lo monta en <body> */
.descriptor-preview-popover {
  max-width: 480px;
  width: 480px;
}
.descriptor-preview-popover .popover-body {
  max-height: 350px;
  overflow-y: auto;
  font-size: 0.875rem;
}
/* Arrastre de descriptores — sin scoped porque con fallback-on-body el clon
   que sigue al cursor se monta en <body> */
.descriptor-drag-chosen {
  box-shadow: var(--kl-shadow-focus);
}
/* Hueco que queda en la lista donde se soltará */
.descriptor-drag-placeholder {
  opacity: 0.4;
  background-color: var(--kl-color-accent-soft);
  outline: 2px dashed var(--kl-color-accent-border);
}
/* Clon que sigue al cursor: Sortable le fija el alto en línea con el del
   descriptor; se recorta para que uno largo no tape la pantalla */
.descriptor-drag-fallback {
  max-height: 140px !important;
  overflow: hidden;
  opacity: 0.95 !important;
  background-color: var(--kl-surface);
  box-shadow: var(--kl-shadow-lg);
  border-radius: var(--kl-radius-md);
  cursor: grabbing;
}
</style>